<template>
  <!-- <v-main>
    <router-view ref="component" :parentComponent="parentComponent"/>
    <dashboard-core-footer />
  </v-main> -->
  <v-app>
    <v-main>
      <router-view ref="component" :parentComponent="parentComponent"/>
    </v-main>

    <dashboard-core-footer />
  </v-app>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { AUTH_LOGOUT } from 'actions/auth'
  export default {
    name: 'DashboardCoreView',
    props: ['parentComponent'],

    components: {
      DashboardCoreFooter: () => import('./Footer'),
    },
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
    },
    created () {
      window.addEventListener('storage', (event) => {
        if (event.storageArea === localStorage) {
          let token = localStorage.getItem('user-token')
          if (token === undefined || token === null) {
            this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'))
          }
        }
      })
    },
    methods: {
      selectLanguage (value) {
        var child = this.$refs.component
        if (child && typeof child.selectLanguage === 'function') {
          child.selectLanguage(value)
        }
      },
    }
  }
</script>
